import {
  CommentSVG,
  DiscordSVG,
  DownArrowSVG,
  FacebookSVG,
  InstagramSVG,
  MoonSVG,
  PlaySVG,
  RssFeedSVG,
  ShareSVG,
  SunSVG,
  TwitterSVG,
  UpArrowSVG,
  YoutubeSVG,
} from "../svg";

// Key should be "left","center" or "right"
function ParagraphAlignmentKeyToClassName(key) {
  switch(key) {
    case "":
      return "textalign-left";
    case "textalign-left":
        return "textalign-left";
    case "textalign-center":
      return "textalign-center"
    case "textalign-right":
      return "textalign-right"
    case "textalign-justified":
      return "textalign-justified"

    default:
      return key;
  }
}

function TextColorKeyToClassName(key) {
  switch(key) {
    case "textcolor-crorange":
        return "textcolor-crorange";
    case "textcolor-crscooter":
      return "textcolor-crscooter"
    case "textcolor-pomegranate":
      return "textcolor-pomegranate"
    case "textcolor-silverchalice":
      return "textcolor-silverchalice"
    
    case "textcolor-tag":
        return "textcolor-tag"
    case "textcolor-crblue":
      return "textcolor-crblue"
    case "textcolor-silver":
      return "textcolor-silver"
    case "textcolor-documentation":
      return "textcolor-documentation"
    case "textcolor-trout":
      return "textcolor-trout"
    case "textcolor-honeygold":
      return "textcolor-honeygold"      
    default:
      return key;
  }
}

function UnderlineColorKeyToClassName(key) {
  switch (key) {
    case "backgroundcolor-crscooter":
      return "border-color-crscooter";
    default:
      return "border-color-crorange";
  }
}

function SVGIconKeyToComponent(key) {
  switch (key) {
    case "comment":
      return <CommentSVG />;
    case "discord":
      return <DiscordSVG />;
    case "down-arrow":
      return <DownArrowSVG />;
    case "facebook":
      return <FacebookSVG />;
    case "instagram":
      return <InstagramSVG />;
    case "moon":
      return <MoonSVG />;
    case "play":
      return <PlaySVG />;
    case "rss-feed":
      return <RssFeedSVG />;
    case "share":
      return <ShareSVG />;
    case "sun":
      return <SunSVG />;
    case "twitter":
      return <TwitterSVG />;
    case "up-arrow":
      return <UpArrowSVG />;
    case "youtube":
      return <YoutubeSVG />;
    default:
      return null;
  }
}

export {
  ParagraphAlignmentKeyToClassName,
  UnderlineColorKeyToClassName,
  SVGIconKeyToComponent,
  TextColorKeyToClassName
};
